export const Gradients = {
  high: "linear-gradient(149.28deg, #4CE3AC 17.86%, #2EBB88 104.37%)",
  low: "linear-gradient(316.04deg, #FB6900 3.82%, #FB9E5B 89.78%)",
  average: "linear-gradient(316.04deg, rgb(239 212 38) 3.82%, rgb(255 232 78) 89.78%)",
};
